module.exports = __webpack_public_path__ + "img/eating.5bed14ff.svg";